export enum CapitalMovementDividendModalMode {
  VIEW = "view",
  EDIT = "edit",
}
